import React, { useState, useEffect } from "react";
import DigitalIdentity from "../Images/DigitalIdentity.png";
import AOS from "aos";
import "aos/dist/aos.css";

const servicesData = [
  {
    id: "digital-identity",
    title: "Digital Identity",
    heading: "QR Code-Based Digital Identity",
    description:
      "One QR code holds it all – your shop, contacts, product catalog, and promotions. No app or website needed!",
    points: [
      "Instant digital presence with just a QR code",
      "Go digital in just 24 hours",
      "Easy sharing with customers and partners",
    ],
    image: DigitalIdentity,
    credit: "Photo by Dan Burton (@dan__burton)",
  },
  {
    id: "retail",
    title: "Retail Management",
    heading: "Manage Your Retail Shop Online",
    description:
      "No tech headaches – run your store with a QR code and simple digital tools!",
    points: [
      "Complete Branding & Mobile-Friendly Sales Tools",
      "Smart Delivery, Cart, & Payment Management",
      "Real-Time Stock, Inventory & Order Tracking",
      "QR Code-Based Ordering & Business Promotion",
      "Order Confirmation, Rejection Handling & WhatsApp Updates",
      "Business Reporting, Analytics & Sales Insights",
    ],
    image:
      "https://images.unsplash.com/photo-1591035897812-79d67f0ba2d6?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "agri",
    title: "Agriculture",
    heading: "🌱 Agriculture Digital Solutions by GeeCom India",
    description:
      "Empowering farmers, FPOs, and rural entrepreneurs with innovative digital tools.",
    points: [
      "Direct Selling & Farm Product Marketing",
      "Organic Certification & Digital Demand Mapping",
      "QR Code-Based Marketing & Promotion",
      "B2B Solutions & Marketplace Integration",
      "Supply Chain & Demand Fulfillment Services",
      "Customizable Digital Shops & Sales Analytics",
    ],
    image:
      "https://images.unsplash.com/photo-1500595046743-cd271d694d30?auto=format&fit=crop&w=800&q=80",
    credit: "Photo by Tim Mossholder (@timmossholder)",
  },
  {
    id: "documentation",
    title: "Documentation",
    heading: "Documentation Solutions",
    description:
      "Digitally record activities, generate reports, and ensure seamless certification.",
    points: [
      "Replace Paper Registers with Smart Digital Diaries",
      "Build & Customize Documentation for Certifications",
      "Automated & Real-Time Report Generation",
      "Track, Store & Access Activity Records Easily",
      "Ensure Data Accuracy, Compliance & Traceability",
      "Multi-Use Documentation for Better Decision-Making",
    ],
    image:
      "https://images.unsplash.com/photo-1600267165302-2c59c3d8f8f9?auto=format&fit=crop&w=800&q=80",
    credit: "Photo by Markus Winkler (@markuswinkler)",
  },
  {
    id: "organic-certification",
    title: "Organic Certification",
    heading: "Digital Tools for Organic Certification",
    description:
      "Easily track organic farming practices and generate compliance reports for certification.",
    points: [
      "Smart Forms to Record Organic Practices",
      "Digital SOP Compliance and Traceability",
      "Instant Certification Status Monitoring",
      "Pre-Audit Preparation and Reporting Tools",
    ],
    image:
      "https://images.unsplash.com/photo-1580910051076-bbd232c8df1f?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "survey-solutions",
    title: "Survey Solutions",
    heading: "Efficient Digital Survey Tools",
    description:
      "Collect, analyze, and visualize field data in real-time using smart survey solutions.",
    points: [
      "GPS-Enabled Data Collection",
      "Custom Form Builder & Response Analytics",
      "Real-Time Field Feedback",
      "Exportable Reports & Visual Dashboards",
    ],
    image:
      "https://images.unsplash.com/photo-1611171711917-b197f16f8914?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "video-training",
    title: "Training via Video",
    heading: "On-Demand Training via Video Modules",
    description:
      "Train farmers, staff, and stakeholders at scale with educational video content.",
    points: [
      "Localized & Easy-to-Understand Video Lessons",
      "Track Completion & Engagement",
      "Offline Accessibility Options",
      "Scalable Training Across Regions",
    ],
    image:
      "https://images.unsplash.com/photo-1584820927498-20a6b7d16a06?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "field-tracking",
    title: "Field Staff Tracking",
    heading: "Field Staff Tracking & Attendance",
    description:
      "Monitor on-ground workforce performance, presence, and location in real-time.",
    points: [
      "Geo-Fenced Attendance & Time Tracking",
      "Daily Reporting Dashboards",
      "Route Mapping and Location Logs",
      "Task-Based Performance Insights",
    ],
    image:
      "https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=800&q=80",
  },
];

const Services = () => {
  const [activeTab, setActiveTab] = useState(servicesData[0].id);
  const activeService = servicesData.find(
    (service) => service.id === activeTab
  );
  useEffect(() => {
    AOS.init({ once: true });
  }, []);
  return (
    <section id="services" className="py-24 bg-gray-50" data-aos="fade-up">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-down">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover our range of digital solutions designed specifically for
            farmers, rural entrepreneurs, and grassroots innovations.
          </p>
        </div>

        <div className="max-w-6xl mx-auto" data-aos="zoom-in">
          <div
            className="flex flex-wrap justify-center mb-12"
            role="tablist"
            aria-label="Service categories"
          >
            {servicesData.map((service) => (
              <button
                key={service.id}
                className={`px-6 py-3 mx-2 mb-3 rounded-full font-medium focus:outline-none transition-colors ${
                  activeTab === service.id
                    ? "bg-blue-600 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
                role="tab"
                aria-selected={activeTab === service.id}
                aria-controls={`panel-${service.id}`}
                onClick={() => setActiveTab(service.id)}
              >
                {service.title}
              </button>
            ))}
          </div>

          <div
            className="bg-white rounded-xl shadow-sm overflow-hidden"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div
              id={`panel-${activeService.id}`}
              role="tabpanel"
              aria-labelledby={`tab-${activeService.id}`}
              className="flex flex-col md:flex-row min-h-[400px]"
            >
              {/* Left: Content */}
              <div
                className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center bg-white"
                data-aos="fade-right"
              >
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  {activeService.heading}
                </h3>
                <p className="text-gray-600 mb-6 text-lg">
                  {activeService.description}
                </p>
                <ul className="space-y-3 mb-8">
                  {activeService.points.map((point, index) => (
                    <li className="flex items-start" key={index}>
                      <svg
                        className="h-6 w-6 text-blue-600 mr-2 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors"
                >
                  Learn more
                  <svg
                    className="ml-2 w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </a>
              </div>

              {/* Right: Image */}
              <div
                className="w-full md:w-1/2 relative h-[400px]"
                data-aos="fade-left"
              >
                <img
                  src={activeService.image}
                  alt={activeService.heading}
                  className="w-full h-full object-cover object-center"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://placehold.co/800x600?text=Service+Image";
                    e.target.classList.add("object-contain", "p-4");
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white opacity-30 pointer-events-none"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
